export default __webpack_public_path__ + "static/media/imagethirteen.dfa9762f.gif";